import { MultiValuedListItems } from '../../../MultiValuedList'

import * as styles from './Items.module.css'

function Items(props) {
  return <MultiValuedListItems {...props} className={styles.items} />
}

export default Items
